export default from './VideoUploader';



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoUploader/index.js